module.exports = __webpack_public_path__ + "img/launch-kl8-website-icon.0bc5ea84.png";